import React from 'react';
import {makeStyles} from '@material-ui/core/styles';

import API from "@beardeddevops/react.api";
import APPCONFIG from 'constants/Config';
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

import Typography from '@material-ui/core/Typography';
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import InputAdornment from "@material-ui/core/InputAdornment";
import MobileStepper from "@material-ui/core/MobileStepper";
import {Button} from "reactstrap";
import {confirmAlert} from "react-confirm-alert";
import {Collections} from "components";
import UniversalModalOverride from "components/UniversalModalOverride";
import SignupAddOns, {getAddOnPrice} from "components/Parts/SignupAddOns";

const planPricingStyles = {
	pricingPlaceholder: {
		background: '#fff',
		border: '3px solid #eee',
		minHeight: '335px',
		padding: '18px'
	},
	placeholderHeader: {
		background: '#e2e8f0',
		borderRadius: '4px',
		height: '34px',
		marginBottom: '18px'
	},
	placeholderPrice: {
		background: '#f1f5f9',
		borderRadius: '4px',
		height: '82px',
		marginBottom: '16px'
	},
	placeholderLine: {
		background: '#edf1f5',
		borderRadius: '3px',
		height: '13px',
		margin: '12px 0'
	},
	pricingEmpty: {
		alignItems: 'center',
		background: '#fff',
		border: '3px solid #eee',
		color: '#64748b',
		display: 'flex',
		justifyContent: 'center',
		minHeight: '335px',
		padding: '24px',
		textAlign: 'center'
	}
};


/**
 *  @property {Accounts_Object} state
 *  @property {object} model
 *  @property {Accounts_Properties} model.properties
 *  @property {Accounts_Is} model.is
 *  @property {Accounts_Has} model.has
 */
export default class Register extends Framework.Components.Object {

	constructor(props) {
		super(props, Types.Accounts_Create._name);
		this.model.requestType = API.RequestType.CREATE;
		this.state.step = 0;
		this.state.showPassword = false;
		this.state.showPasswordRetype = false;
		this.state.subscriptionOptions = [];
		this.state.subscriptionOptionsLoading = true;
		this.state.signupAddOnsAvailable = true;

		this.shouldAutoLoad = false;
		this.handleNext = this.handleNext.bind(this);
		this.handlePrevious = this.handlePrevious.bind(this);
		this.checkAgreement = this.checkAgreement.bind(this)

	}

	componentDidMount() {
		super.componentDidMount()
		this.state.tos = false
		this.state.selectedAddOns = []
		const queryUpdates = this.getQueryParamUpdates();
		if (Object.keys(queryUpdates).length > 0) {
			Object.assign(this.state, queryUpdates);
			this.setState(queryUpdates);
		}
		this.loadSubscriptionOptions().then();
		SignupAddOns.preload().then((signupAddOns) => {
			this.setState({
				signupAddOnsAvailable: SignupAddOns.preloadError || (Array.isArray(signupAddOns) && signupAddOns.length > 0)
			});
		});
	}

	getQueryParamUpdates = () => {
		const search = this.props.location && this.props.location.search;
		if (!search) {
			return {};
		}

		const params = new URLSearchParams(search);
		const updates = {};
		const excludedParams = new Set(['password', 'password_repeat', 'tos', 'selectedAddOns']);

		Object.keys(this.model.properties).forEach((key) => {
			if (excludedParams.has(key) || !params.has(key)) {
				return;
			}

			const value = params.get(key);
			if (value === null || value === '') {
				return;
			}

			if (key === 'type') {
				const parsedType = Number.parseInt(value, 10);
				updates[key] = Number.isNaN(parsedType) ? value : parsedType;
				return;
			}

			updates[key] = value;
		});

		if (params.has('step')) {
			const step = Number.parseInt(params.get('step'), 10);
			if (!Number.isNaN(step) && step >= 0) {
				updates.step = step;
			}
		}

		return updates;
	};

	loadSubscriptionOptions = async () => {
		const subscriptionsModel = new API.BuildClass(Types.Subscriptions._name, API.RequestType.READ_ALL);
		subscriptionsModel.limit = null;
		subscriptionsModel.source = 'select';

		try {
			const response = await subscriptionsModel.submit(null, API.RequestType.READ_ALL);
			const subscriptionOptions = response && Array.isArray(response.items) ? response.items : [];
			const selectedSubscription = subscriptionOptions.find((subscription) => String(subscription.id) === String(this.state.type));
			this.setState({
				subscriptionOptions,
				subscriptionOptionsLoading: false,
				...(selectedSubscription ? {subscriptions: selectedSubscription} : {})
			});
		} catch (error) {
			this.setState({subscriptionOptionsLoading: false});
		}
	};

	getSteps() {
		return ['Create Login', 'FFL Details', 'Business Address'];
	}

	handleNext() {
		let shouldContinue = API.Validator.process(this, this.requestType, true, null, this.state.step + 1);
		let doesPasswordsMatch = this.state.password === this.state.password_repeat;
		if (!doesPasswordsMatch) {
			this.setState({ password_repeat_error: "Passwords must match" });
		}
		if (shouldContinue && doesPasswordsMatch) {
			this.setState({"step": this.state.step + 1});
		}
	};

	handlePrevious = () => {
		this.setState({"step": this.state.step - 1});
	};

	/**
	 * @param {Ffls_Object} ffl
	 */
	loadFFL = (ffl) => {
		this.setState({
			ffl: ffl.ffl,
			name_company: ffl.name_business ? ffl.name_business : ffl.name_license,
			name_legal: ffl.name_business ? ffl.name_license : '',
			street_1: ffl.street,
			city: ffl.city,
			state: ffl.state,
			zip: ffl.zip.substring(0, 5)
		});
	};

	checkAgreement() {
		if (!this.state.tos) {
			confirmAlert({
				title: 'Accept ',
				message: <p className={"muted"}> I agree to the <a href="https://fflboss.com/terms-of-service/" target={'_blank'}>Terms and
					Conditions</a> and I agree to the <a href="https://fflboss.com/privacy-policy/" target={'_blank'}>Privacy Policy</a></p>,
				buttons: [
					{
						label: 'Yes',
						color: 'danger',
						onClick: () => {
							this.handleSubmit().then(() => {

							}).catch(() => {

							})
						}
					},
					{
						label: 'No',
						onClick: () => {
							return false
						}
					}
				]
			});
		} else {
			this.handleSubmit().then(() => {

			}).catch(() => {

			})
		}
	}

	/**
	 *
	 * @param event
	 * @returns {Promise<boolean>}
	 */
	handleSubmit = async event => {
		if (typeof event !== 'undefined') event.preventDefault();
		this.setState({loading: true});
		if (this.handleProcess(null, null)) {
			try {
				// console.log("logging this", this);
				// return;
				await this.model.submit(this, API.RequestType.CREATE);
			} catch (e) {
				this.setState({loading: false});
				return false;
			}
			this.props.history.push('/dashboard');
		} else {
			this.setState({loading: false});
		}
		return false;
	};

	handleCheckbox = () => {
		this.setState({tos: !this.state.tos})
	};

	/**
	 *
	 * @returns {JSX.Element}
	 */
	render() {
		/** @type {Accounts_Create_Properties} properties */
		let properties = this.model.properties;
		/** @type {Accounts_Create_Object} object */
		let object = this.state;
		let {loading, step} = this.state;
		const subscriptionOptions = Array.isArray(object.subscriptionOptions) ? object.subscriptionOptions : [];
		const showSignupAddOns = object.signupAddOnsAvailable;
		const selectedBasePlan = object.subscriptions || subscriptionOptions.find((subscription) => String(subscription.id) === String(object.type));
		const basePlanPrice = getAddOnPrice(selectedBasePlan && selectedBasePlan.price);
		const steps = this.getSteps();
		const classes = makeStyles((theme) => ({
			root: {
				width: '100%',
			},
			button: {
				marginRight: theme.spacing(1),
			},
			instructions: {
				marginTop: theme.spacing(1),
				marginBottom: theme.spacing(1),
			},
		}));
		let label = (
			<p>I agree to the <a href="https://fflboss.com/terms-of-service/" target={'_blank'}>Terms and Conditions</a> and I agree to the <a
				href="https://fflboss.com/privacy-policy/" target={'_blank'}>Privacy Policy</a></p>)
		// noinspection JSIncompatibleTypesComparison
		return (
			<div className="page-signup" style={{backgroundColor: '#fff', overflow: 'auto'}}>
				<div className="main-body" style={{maxWidth: step === 1 && showSignupAddOns ? '1200px' : '800px', margin: '0 auto', paddingTop: '50px'}}>
					<div className="body-inner">
						<Card>

							<CardContent>
								<section className="logo text-center">
									<h1 style={{marginBottom: '10px'}}>{APPCONFIG.image}</h1>
								</section>

								<Stepper activeStep={step}>
									{steps.map((label, index) => {
										const stepProps = {};
										const labelProps = {};
										return (
											<Step key={label} {...stepProps}>
												<StepLabel {...labelProps}>{label}</StepLabel>
											</Step>
										);
									})}
								</Stepper>
								<br/>

								{/*#region Step 1*/}
								{step === 0 &&
								<fieldset>

									<div className={"row"}>
										<div className={"col-md"}>
											<div className="form-group">
												<Framework.Elements.TextField
													label={'First Name'}
													value={object.name_first}
													error={object.name_first_error}
													property={properties.name_first}
													update={this.handleTextFieldPropertyUpdate}
													variant={"standard"}
												/>
											</div>
										</div>
										<div className={"col-md"}>
											<div className="form-group">
												<Framework.Elements.TextField
													label={'Last Name'}
													value={object.name_last}
													error={object.name_last_error}
													property={properties.name_last}
													update={this.handleTextFieldPropertyUpdate}
													variant={"standard"}
												/>
											</div>
										</div>
									</div>
									<div className={"row"}>
										<div className={"col-md"}>
											<div className="form-group">
												<Framework.Elements.TextField
													value={object.email}
													error={object.email_error}
													property={properties.email}
													update={this.handleTextFieldPropertyUpdate}
													variant={"standard"}
												/>
											</div>
										</div>
										<div className={"col-md"}>
											<div className="form-group">
												<Framework.Elements.PhoneNumber
													value={object.phone}
													error={object.phone_error}
													property={properties.phone}
													update={this.handleTextFieldPropertyUpdate}
													variant={"standard"}
												/>
											</div>
										</div>

									</div>

									<div className={"row"}>
										<div className={"col-md"}>
											<div className="form-group">
												<Framework.Elements.TextField
													value={object.password}
													error={object.password_error}
													property={properties.password}
													update={this.handleTextFieldPropertyUpdate}
													variant={"standard"}
													type={this.state.showPassword ? "text" : "password"}
													InputProps={{
														endAdornment: (
															<InputAdornment position={"end"}>
																<i
																	className="fa fa-eye"
																	onClick={() => this.setState({ showPassword: !this.state.showPassword })}
																	style={{ cursor: "pointer" }}
																/>
															</InputAdornment>
														),
														shrink: false
													}}
												/>
											</div>
										</div>
										<div className={"col-md"}>
											<div className="form-group">
												<Framework.Elements.TextField
													label={'Retype Password'}
													value={object.password_repeat}
													error={object.password_repeat_error}
													property={properties.password_repeat}
													update={this.handleTextFieldPropertyUpdate}
													variant={"standard"}
													type={this.state.showPasswordRetype ? "text" : "password"}
													InputProps={{
														endAdornment: (
															<InputAdornment position={"end"}>
																<i
																	className="fa fa-eye"
																	onClick={() => this.setState({ showPasswordRetype: !this.state.showPasswordRetype })}
																	style={{ cursor: "pointer" }}
																/>
															</InputAdornment>
														),
														shrink: false
													}}
												/>
											</div>
										</div>
									</div>
								</fieldset>}
								{/*#endregion*/}

								{/*#region Step 3*/}
								{step === 1 &&
								<div>
									<div className={'row'}>
										<div className={showSignupAddOns ? 'col-md-4' : 'col-md-6'}>

											<div className="form-group">
												<Framework.Elements.Select
													id={'id'}
													limit={null}
													shouldLoad={this.state.loaded}
													update={this.handleSelectPropertyUpdate}
													property={properties.type}
													value={object.type}
													error={object.type_error}
													object={selectedBasePlan}
													objects={subscriptionOptions}
													text={'description(price'}
													label={'Base Plan'}
													filter={
														/** @param {Subscriptions_Properties} option */
															(option) => !option.id.includes('ent')
													}
												/>
											</div>

											<div className={'row'}>
												<div className={'col-8'}>
													<div className="form-group">
														<Framework.Elements.TextField
															label={'FFL'}
															property={properties.ffl}
															value={object.ffl}
															error={object.ffl_error}
															update={this.handleTextFieldPropertyUpdate}
															InputProps={{
																inputComponent: Framework.Masks.FFL,
															}}
														/>
													</div>
												</div>
												<div className={'col-4'}>
													<Button onClick={this.toggle('modalFFLLookup')} color="primary"
														style={{position: 'absolute', right: 0}}>
														<i className={"fa fa-search"}/>
														<span className="hidden-xs">&nbsp;&nbsp;FFL Lookup</span>
													</Button>

												</div>
											</div>

											<div className="form-group">
												<Framework.Elements.TextField
													label={'Company Name'}
													value={object.name_company}
													error={object.name_company_error}
													property={properties.name_company}
													update={this.handleTextFieldPropertyUpdate}
													variant={"standard"}
												/>
											</div>

											<div className="form-group">
												<Framework.Elements.TextField
													label={'Company Name Legal'}
													value={object.name_legal}
													error={object.name_legal_error}
													property={properties.name_legal}
													update={this.handleTextFieldPropertyUpdate}
													variant={"standard"}
												/>
											</div>

											<UniversalModalOverride
												locations={[]}
												states={[]}
												history={this.props.history}
												name={"FFL Lookup"}
												object={Collections.FFLLookup}
												toggle={this.state.modalFFLLookup}
												reportClose={this.reportClose('modalFFLLookup')}
												afterSave={this.loadFFL}
												size={"xl"}
												hasSubmit={false}
												objectProps={{
													currentFFL: object.ffl
												}}
											/>
										</div>

										<div className={showSignupAddOns ? 'col-md-4' : 'col-md-6'}>

											{selectedBasePlan
												? <div className={"pricing hover-effect"} dangerouslySetInnerHTML={{__html: selectedBasePlan.code}}/>
												: object.subscriptionOptionsLoading ? <div aria-label="Loading plan details" style={planPricingStyles.pricingPlaceholder}>
													<div style={planPricingStyles.placeholderHeader}/>
													<div style={planPricingStyles.placeholderPrice}/>
													{[1, 2, 3, 4].map((line) => <div key={line} style={planPricingStyles.placeholderLine}/>)}
												</div> : <div style={planPricingStyles.pricingEmpty}>Select a base plan to view its details.</div>}

										</div>

										{showSignupAddOns && <div className={"col-md-4"}>
											<SignupAddOns
												selectedAddOns={object.selectedAddOns}
												onSelectedAddOnsChange={(selectedAddOns) => this.setState({selectedAddOns})}
												onAvailabilityChange={(signupAddOnsAvailable) => this.setState({signupAddOnsAvailable})}
												basePlanPrice={basePlanPrice}
												hasBasePlan={!!selectedBasePlan}
											/>
										</div>}
									</div>
								</div>}
								{/*#endregion*/}

								{/*#region Step 2*/}
								{step === 2 &&
								<fieldset>
									<div className={"row"}>
										<div className={"col-md-7"}>
											<div className="form-group">
												<Framework.Elements.TextField
													value={object.street_1}
													error={object.street_1_error}
													property={properties.street_1}
													update={this.handleTextFieldPropertyUpdate}
													variant={"standard"}
												/>
											</div>
										</div>
										<div className={"col-md-5"}>
											<div className="form-group">
												<Framework.Elements.TextField
													value={object.street_2}
													error={object.street_2_error}
													property={properties.street_2}
													update={this.handleTextFieldPropertyUpdate}
													variant={"standard"}
												/>
											</div>
										</div>
									</div>
									<div className={"row"}>
										<div className={"col-md-4"}>
											<div className="form-group">
												<Framework.Elements.TextField
													value={object.city}
													error={object.city_error}
													property={properties.city}
													update={this.handleTextFieldPropertyUpdate}
													variant={"standard"}
												/>
											</div>
										</div>
										<div className={"col-md-5"}>
											<div className="form-group" style={{paddingTop: '10px'}}>
												<Framework.Elements.Select
													shouldLoad={this.state.loaded}
													update={this.handleSelectPropertyUpdate}
													property={properties.state}
													value={object.state}
													error={object.state_error}
													autoload={true}
													id={'short'}
													model={Types.States._name}
													nullable={false}
													limit={null}
												/>
											</div>
										</div>
										<div className={"col-md-3"}>
											<div className="form-group">
												<Framework.Elements.ZipCode
													value={object.zip}
													error={object.zip_error}
													property={properties.zip}
													update={this.handleTextFieldPropertyUpdate}
													variant={"standard"}
												/>
											</div>
										</div>
									</div>

									<div className={"form-group"} style={{textAlign: 'center'}}>
										<Framework.Elements.Checkbox
											value={object.tos !== null && object.tos !== '' ? object.tos : false}
											property={properties.tos}
											error={object.tos_error}
											update={() => (this.setState({tos: !this.state.tos}))}
											color="primary"
											label={'Terms of Service'}
										/>
									</div>

								</fieldset>}
								{/*#endregion*/}


							</CardContent>

							<CardActions>

								<div style={{width: '100%'}}>
									<div>
										{step === 0 ?
											<Button onClick={() => this.props.history.push('/login')} className={classes.button}>
												Back
											</Button>
											:
											<Button onClick={this.handlePrevious} className={classes.button}>
												Back
											</Button>}
										<Button
											variant="contained"
											color="primary"
											onClick={step === steps.length - 1 ? this.checkAgreement : this.handleNext}
											className={classes.button}
											style={{'float': 'right'}}
										>
											{step === steps.length - 1 ? 'Finish' : 'Next'}
										</Button>
									</div>
								</div>

							</CardActions>

						</Card>
						<Framework.Elements.LoadingSpinner isLoading={loading}/>
					</div>
				</div>
			</div>
		);
	}
}


